$(document).ready(function () {
    if ($(".critical-notice").length > 0) {
      CloseNotice();

      /**
       * Animates the notice away and triggers ajax function to set session state to notice closed
       **/
      function CloseNotice() {
  
        $(".critical-notice__close").on("click", function (evt) {

          // get details for ajax call
          var notice = $(this).closest('.critical-notice');
          var absoluteBase = notice.attr("data-absolutebase");
          var currentLink = notice.attr("data-currentlink");
          var allowedAction = "setcriticalnoticestatetoclosed"; // function on PageController
          var bannerID = notice.attr("data-bannerid");          
          if (currentLink == null || currentLink == "") {
            currentLink = "/home";
          }          
          // console.log(absoluteBase + currentLink + '/' + allowedAction + '/' + bannerID);
          
          // animate the notice away
          notice.slideUp();
  
          // fire ajax to call allowedAction to set session state to notice closed
          $.ajax({
            url: absoluteBase + currentLink + '/' + allowedAction + '/' + bannerID,
            type: "GET",
            data: {},
            response: function (response) {
              // console.log(response);
            },
          });
        });
      }
    }
  });
  